var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLegendDoorOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6405_466532)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2E908B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3263 13.358C16.739 12.3603 15.2825 12.3499 12.6737 13.358L13.4129 17.1297C15.9898 16.1545 15.9697 16.1352 18.5871 17.1297L19.3263 13.358ZM19.3263 13.358C20.435 12.9828 21.3713 13.4855 21.9873 13.7368M13.5805 21.7411C15.76 21.8472 16.4984 21.8523 18.7548 21.7411M8.5 17.3962L11.1953 14.8677L11.1954 11.8519C11.1954 9.76985 12.8501 8.08203 14.8912 8.08203H17.1088C19.1499 8.08203 20.8046 9.76985 20.8046 11.8519L20.8046 14.8677L23.5 17.3962M12.6737 13.3598C12.0577 13.1085 10.9736 13.1336 10.0866 13.7368M20.8046 18.6376V21.6535C20.8046 22.9027 19.8118 23.9154 18.5871 23.9154H13.4129C12.1882 23.9154 11.1954 22.9027 11.1954 21.6535L11.1953 18.6376",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6405_466532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLegendDoorOpen);
export default __webpack_public_path__ + "static/media/map-legend-door-open.73fd033153c3bb5259a2cf5971d73ea4.svg";
export { ForwardRef as ReactComponent };